export const normalizeGuid = (id?: string) =>
  (id || '')
    .replace(/[\{\}]/g, '') // remove optional braces
    .replace(/-/g, '') // remove hyphens
    .toLowerCase();
